var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$route.params.tab == 'thirdPartyTypes')?_c('div',[_c('page-component',{attrs:{"pageTitle":"Third Party Types","headers":_vm.headers,"items":_vm.thirdPartyTypes,"buttons":[
      {
        text: '+ Add New Third Party Type',
        to: { params: { form: 'AddEditForm' } },
      },
    ]},scopedSlots:_vm._u([{key:`item.actions`,fn:function({ item }){return [_c('nxg-action-btn',{attrs:{"type":"edit"},on:{"click":function($event){return _vm.editThirdPartyType(item)}}}),_c('nxg-action-btn',{attrs:{"type":"delete","item-type":"THIRD_PARTY_TYPE","item":item}})]}}],null,true)}),_c('add-edit-form',{attrs:{"thirdPartyTypes":_vm.thirdPartyTypes}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }